/* Olivia Star — desktop arrows for product media gallery.
   Triggers the *button inside* each thumbnail <li> — that's where Dawn binds
   its click handler (see media-gallery.js setActiveMedia). */
(function () {
  function init() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    if (gallery.dataset.oliviaArrowsAdded) return;
    gallery.dataset.oliviaArrowsAdded = '1';

    const viewer = gallery.querySelector('[id^="GalleryViewer"]') || gallery.querySelector('.product__media-list');
    const thumbsRoot = gallery.querySelector('[id^="GalleryThumbnails"]') || gallery;
    if (!viewer) return;

    // Only thumbnails that are actually visible. Media belonging to another
    // variant stays in the DOM but is display:none — clicking such a thumbnail
    // made a hidden slide active and collapsed the whole gallery to an empty
    // frame, which is the "photo disappears" bug.
    const thumbButtons = () =>
      [...thumbsRoot.querySelectorAll('[data-target]')]
        .filter((li) => li.offsetParent !== null)
        .map((li) => li.querySelector('button'))
        .filter(Boolean);

    const currentIndex = () => {
      const btns = thumbButtons();
      const i = btns.findIndex((b) => b.getAttribute('aria-current') === 'true');
      if (i >= 0) return i;
      // fallback: which viewer slide has .is-active
      const items = [...viewer.querySelectorAll('[data-media-id]')];
      const j = items.findIndex((it) => it.classList.contains('is-active'));
      return j >= 0 ? j : 0;
    };

    const go = (delta) => {
      const btns = thumbButtons();
      if (btns.length < 2) return;
      const next = (currentIndex() + delta + btns.length) % btns.length;
      // images are lazy — warm the target and its neighbours so the frame is
      // never blank while the file is still loading
      [next - 1, next, next + 1].forEach((i) => {
        const btn = btns[(i + btns.length) % btns.length];
        const id = btn && btn.dataset ? btn.dataset.target : null;
        const slide = id ? viewer.querySelector('[data-media-id="' + id + '"]') : null;
        (slide || btn).querySelectorAll('img').forEach((img) => {
          if (img.loading === 'lazy') img.loading = 'eager';
        });
      });
      btns[next].click();
    };

    // Anchor arrows directly to the slider/viewer so vertical centering is on
    // the visible main media, not on a wrapper that also contains thumbnails.
    const wrap = viewer;
    wrap.classList.add('olivia-pdp-arrows-host');

    const make = (cls, label, path) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'olivia-pdp-arrow ' + cls;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      return b;
    };

    const prev = make('olivia-pdp-arrow--prev', 'Previous photo', 'M15 6l-6 6 6 6');
    prev.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(-1); });

    const next = make('olivia-pdp-arrow--next', 'Next photo', 'M9 6l6 6-6 6');
    next.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(1); });

    wrap.appendChild(prev);
    wrap.appendChild(next);

    wrap.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
